// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

const flagRule = css({
    width: '16px',
    height: '11px',
    display: 'inline-block',
    background: 'url("../assets/images/flags.png") no-repeat',
});

const positions = {
    jp: '0 -11px',
    us: '-16px -11px',
    eu: '-16px 0',
};

const flagPosition = key =>
    css({
        backgroundPosition: positions[key],
    });

@observer
export default class Flag extends React.Component {
    props: {
        country: string,
    };

    render() {
        return <div { ...flagRule } { ...flagPosition(this.props.country) } />;
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Flag/index.js